<script>
import salesApi from "@/api/web/bi/sales.js";
import common from "@/common/mixins/common.js";
import NumberInput from "@/components/NumberInput.vue";
import Vue from "vue";

export default {
  props: {
    // 商品类型
    goodsTypes: {
      type: Array,
      default: () => [],
    },
    // 语言
    lang: {
      type: String,
      default: "",
    },
    pickerOptions: {
      type: Object,
      default: () => {
      },
    }
  },
  watch: {
    goodsTypeValue(newValue, oldValue) {
      this.query.goods_type_value = newValue[newValue.length - 1];
    },
    time2(newValue, oldValue) {
      this.query.time2 = newValue[0] + "-" + newValue[1];
    },
  },
  data() {
    return {
      tableData: [],
      // 搜索参数
      query: {
        page: 1,
        size: 10,
        total: 100,
        time2: "",
        goods_type_value: "",//商品类型[用于提交]
      },
      goodsTypeValue: "",  // 查询商品类型
      time2: [], // 时间选择器
      numShow: {},
      priceshow: {},
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      salesApi.GetFirstBuy(this.query).then(res => {
        const { total, page_size, page, data } = res.data.data;
        this.tableData = data;
        this.query.total = total;
        this.query.page = page;
        this.query.size = page_size;

        if (data.length > 0 ){
          for (let i = 0; i < data.length; i++) {
            Vue.set(this.numShow, data[i].sku, "Loding...");
            Vue.set(this.priceshow, data[i].sku, "Loding...");
            salesApi.GetOrderCartNumAndPrice(data[i].sku).then(res2 => {
              const resData = res2.data.data
              Vue.set(this.numShow, data[i].sku, resData.num);
              Vue.set(this.priceshow, data[i].sku, resData.price);
            });
          }
        }
      });
    },
    findQuery() {
      // console.log(this.goodTypeKey2name)
      // console.log(this.query);
      this.getData();
      
    },
    // 点击页码
    handleCurrentChange(val) {
      this.query.page = val;
      this.getData();
    },
  },
};
</script>

<template>
  <div>

    <div class="selType">
      分类:
      <el-cascader v-model="goodsTypeValue" :options="goodsTypes" :placeholder="$t('Please Select Product Category')"
                   :props="{ checkStrictly: true }" clearable size="medium" style="width: 260px">
      </el-cascader>
      &nbsp;&nbsp;&nbsp;
      时间:
      <el-date-picker
        v-model="time2"
        :picker-options="pickerOptions"
        align="right"
        end-placeholder="结束日期"
        range-separator="至"
        start-placeholder="开始日期"
        type="datetimerange"
        value-format="timestamp">
      </el-date-picker>
      &nbsp;
      <el-button icon="el-icon-search" size="mini" type="primary" @click="findQuery">搜索</el-button>
    </div>
    <div>
      <el-table
        :data="tableData"
        border
        style="width: 100%">
        <el-table-column align="center" label="订单编码" prop="item_no" width="150">
          <template slot-scope="{row}">
            <div>{{ row.order_sn }}</div>
          </template>
        </el-table-column>

         <el-table-column align="center" label="订单日期" width="120">
          <template slot-scope="{row}">
            <div>{{ row.order_time }}</div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="sku" width="120">
          <template slot-scope="{row}">
            <div>{{ row.sku }}</div>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          label="图片" width="50">
          <template slot-scope="{row}">
            <viewer>
              <img :src="`https://hwimg.xmvogue.com/thumb/${row.sku}.jpg?x-oss-process=style/440`" height="30"
                   style="cursor: pointer;" width="30">
            </viewer>
          </template>
        </el-table-column>

        <el-table-column label="名称" width="260">
          <template slot-scope="{row}">
            <div v-if="lang==='zh-CN'">
              <el-input v-model="row.cn" size="mini"></el-input>
            </div>
            <div v-else>
              <el-input v-model="row.en" size="mini"></el-input>
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="大类">
          <template slot-scope="{row}">
            <div>{{ row.b_type }}</div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="中类">
          <template slot-scope="{row}">
            <div>{{ row.m_type }}</div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="小类">
          <template slot-scope="{row}">
            <div>{{ row.s_type }}</div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="4级小类">
          <template slot-scope="{row}">
            <div v-if="row.type4">{{ row.type4 }}</div>
            <div v-else>未定义</div>
          </template>
        </el-table-column>


        <el-table-column align="center" label="订货数量">
          <template slot-scope="{row}">
           <!-- {{ row.m_type }} -->
           <div v-text="numShow[row.sku]"></div>
          </template>
        </el-table-column>

        <el-table-column align="center" label="订货金额">
          <template slot-scope="{row}">
            <div v-text="priceshow[row.sku]"></div>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page.sync="query.page"
        :page-size="query.size"
        :total="query.total"
        layout="total, prev, pager, next"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.selType {
  background: #fff;
  border: 1px solid #ccc;
  padding: 10px 5px;
}
</style>